import {
  apiFetch,
  apiFetchJson,
  apiFetchWithoutBearer,
  apiUrl,
  ensureValidAccessToken,
  parseApiResponse,
} from '../../config/apiBase';

/**
 * @param {string} srvNo
 * @param {{ asGuest?: boolean }} [options] asGuest — true면 Bearer 없이 조회(비패널·로그아웃 후 reqType 미포함).
 */
export async function postSurveyOfflineDetail(srvNo, options = {}) {
  const init = {
    method: 'POST',
    body: JSON.stringify({ srvNo }),
  };
  const res = options.asGuest
    ? await apiFetchWithoutBearer('/api/survey-offline/detail', { ...init, credentials: 'omit' })
    : await apiFetch('/api/survey-offline/detail', init);
  if (res.status === 404) return null;
  if (!res.ok) return null;
  return parseApiResponse(res);
}

/** 3.0 getSurveyOfflineList — 비로그인 허용 */
export async function postSurveyOfflineList(page, size, alignColVal) {
  const res = await apiFetchWithoutBearer('/api/survey-offline/list', {
    method: 'POST',
    body: JSON.stringify({ page, size, alignColVal }),
  });
  return parseApiResponse(res);
}

export async function postSurveyOfflineListEligible(page, size, alignColVal) {
  return apiFetchJson('/api/survey-offline/list-eligible', {
    method: 'POST',
    body: JSON.stringify({ page, size, alignColVal }),
  });
}

/** 비로그인 메인용 (fetch + apiUrl) */
export function surveyOfflinePublicListUrl(page, pageSize) {
  const qs = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  return apiUrl(`/api/survey-offline/list?${qs.toString()}`);
}

export async function fetchSurveyOfflinePublicList(page, pageSize) {
  const token = await ensureValidAccessToken();
  const res = await fetch(surveyOfflinePublicListUrl(page, pageSize), {
    method: 'GET',
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return parseApiResponse(res);
}

export async function postSurveyOfflineInvite(body) {
  return apiFetchJson('/api/survey-offline/invite', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
}

export async function postSurveyOfflineInvitePreviewSms(body) {
  return apiFetchJson('/api/survey-offline/invite/preview-sms', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
}

export async function postSurveyOfflineInvitePreviewEmail(body) {
  return apiFetchJson('/api/survey-offline/invite/preview-email', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
}
